exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".w-200[data-v-7474c73b]{width:200px}.action-btn[data-v-7474c73b]{width:70px!important;height:40px!important}.form-content[data-v-7474c73b]{width:800px}.num-input[data-v-7474c73b]{width:120px}body .el-table colgroup.gutter[data-v-7474c73b],body .el-table th.gutter[data-v-7474c73b]{display:table-cell!important}", ""]);

// exports
